import { useState } from "react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export const Footer = () => {
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [sending, setSending] = useState(false);

  const subscribe = async () => {
    const email = newsletterEmail.trim();
    if (!email || !email.includes("@")) {
      toast.error("Pop in a valid email address");
      return;
    }
    setSending(true);
    try {
      const res = await fetch(`${API}/api/newsletter/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      toast.success("You're in! First dibs on new flavours and deals.");
      setNewsletterEmail("");
    } catch {
      toast.error("Couldn't add you just now — try again in a moment");
    } finally {
      setSending(false);
    }
  };

  return (
    <footer className="bg-[#2B0B3C] text-white py-16" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-wrap justify-between gap-10">
          <div>
            <div className="bg-white border-[3px] border-black/20 rounded-2xl px-5 py-3 inline-block">
              <img src="/logo.png" alt="Proppa Foods" className="h-10 w-auto" />
            </div>
            <p className="mt-5 text-sm font-medium text-white/55 max-w-xs">
              Proppadoms, dips and Bombay mix. Snacks, done proppa.
            </p>
          </div>
          <div className="text-sm font-medium text-white/65 space-y-2">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FFD600] mb-3">Shop</p>
            <p>Proppadoms · Mango Chutney</p>
            <p>Bombay Mix · Dip Deals</p>
            <p>Merch & Gifts</p>
          </div>
          <div className="text-sm font-medium text-white/65 space-y-2">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FFD600] mb-3">Stay in the loop</p>
            <p className="max-w-xs">New flavours, bundle deals and the odd treat — straight to your inbox.</p>
            <div className="flex gap-2 pt-1">
              <input
                type="email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && subscribe()}
                placeholder="you@email.com"
                data-testid="newsletter-email-input"
                className="h-12 w-56 rounded-full bg-white/10 border border-white/15 px-5 text-sm text-white placeholder:text-white/35 outline-none focus:border-[#FFD600] transition-colors duration-200"
              />
              <button
                onClick={subscribe}
                disabled={sending}
                data-testid="newsletter-signup-btn"
                className="h-12 px-6 rounded-full bg-[#FF6B00] text-white font-display font-bold text-xs uppercase tracking-wide hover:bg-[#FFD600] hover:text-[#2B0B3C] transition-colors duration-200 disabled:opacity-50"
              >
                {sending ? "…" : "Sign up"}
              </button>
            </div>
          </div>
          <div className="text-sm font-medium text-white/65 space-y-2">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FFD600] mb-3">Trade</p>
            <a href="#wholesale" data-testid="footer-wholesale-link" className="block hover:text-[#FF6B00] transition-colors duration-200">Wholesale enquiries</a>
            <a href="/trade" data-testid="footer-trade-link" className="block hover:text-[#FF6B00] transition-colors duration-200">Trade sign in</a>
            <a href="/admin" data-testid="footer-admin-link" className="block hover:text-[#FF6B00] transition-colors duration-200">Shop admin</a>
            <p>hello@proppafoods.com</p>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t-2 border-white/10 flex flex-wrap justify-between gap-4 text-xs font-medium text-white/40">
          <p>© {new Date().getFullYear()} Proppa Foods. Snacks, done proppa.</p>
          <p>Crack · Dip · Crunch</p>
        </div>
      </div>
    </footer>
  );
};
